import React from 'react'
import PropTypes from 'prop-types'

import { BoldTitle } from './styles'

const Title = ({ children, style }) => (
  <BoldTitle style={style}>{children}</BoldTitle>
)

Title.propTypes = {
  children: PropTypes.string.isRequired,
  style: PropTypes.shape({}),
}

Title.defaultProps = {
  style: null,
}

export default Title
